import { combineReducers } from '@reduxjs/toolkit';

const reducer = combineReducers({});

export * from './purchases-api-slice';

export default reducer;
